import React from 'react';

function SubscribeThanksForm({ size, children }) {
  return (
    <div className={`subscribe-${size}-form`}>
      <h3 className={`subscribe-${size}-banner`}>Hear From Us</h3>
      <hr className={`subscribe-${size}-border`} />
      <div className={`subscribe-${size}-thanks-image`} />
      {children}
    </div>
  );
}

export default SubscribeThanksForm;
